import React from "react";
import BasicsInfo from "../Sections/BasicsInfo";
import BasicModule from "../Sections/BasicModule";
import { Link } from "react-router-dom";

const CourseDetail = ({ course, loading }) => {
  if (loading) {
    return <div className="mt-28 text-center">Loading...</div>;
  }
  if (!course) {
    return <div className="mt-28 text-center">Course not found.</div>;
  }

  return (
    <div className="mt-28">
      <h1
        style={{ fontFamily: "Josefin Sans, sans-serif" }}
        className="font30 text-center mt-12 extraBold"
      >
        {course.title}
      </h1>
      <div className="flex flex-wrap justify-evenly w-[90%] text-[#403f58] m-auto rounded-xl mb-10">
        <main>
          <BasicsInfo
            date={course.date}
            time={course.time}
            language={course.language}
            days={course.days}
          />
        </main>
        <main>
          <BasicModule modules={course.modules} />
        </main>
      </div>
      <Link to="/payment-info" state={{ course }}>
        <button className="block m-auto mb-10 py-3 font-semibold px-4 border bg-green-500 text-white p-1 rounded-lg ">
          Book your slots for ₹ {course.price}
        </button>
      </Link>
    </div>
  );
};

export default CourseDetail;
